import { cn } from "@/lib/cn";

interface BrandLogoProps {
  compact?: boolean;
  subtitle?: string;
  inverse?: boolean;
  className?: string;
}

export function BrandLogo({
  compact = false,
  subtitle,
  inverse = false,
  className,
}: BrandLogoProps) {
  return (
    <div className={cn("flex min-w-0 items-center gap-3", className)}>
      <img
        src="/brand/ledgerly-mark.svg"
        alt=""
        aria-hidden="true"
        className={cn(
          "shrink-0 rounded-xl shadow-sm",
          compact ? "h-9 w-9" : "h-11 w-11",
        )}
      />
      <div className="min-w-0">
        <p
          className={cn(
            "truncate font-black tracking-[-0.02em]",
            compact ? "text-base" : "text-lg",
            inverse ? "text-white" : "text-ink",
          )}
        >
          Ledgerly <span className="text-gold-500">by Mark</span>
        </p>
        {subtitle ? (
          <p
            className={cn(
              "truncate text-xs",
              inverse ? "text-white/65" : "text-ink-muted",
            )}
          >
            {subtitle}
          </p>
        ) : null}
      </div>
    </div>
  );
}
